import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';
import arrow from '../../../assets/images/svgs/icons/arrow_down.svg';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		return {
			step: state.step,
			results: state.results,
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class EconomicalScoreTrackerFourPlayerTakeFromPool extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	poolVal (currentValue, unit) {
		let poolVal = currentValue || 0;

		if (unit === '$' && unit === '€') {
			poolVal = `€${poolVal}`
		} else {
			poolVal = `${poolVal}${unit}`
		}

		return poolVal;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { currentValue, window, unit } = this.props;
		const max = (window.current && window.current.answers && window.current.answers.range) ? window.current.answers.range.max : null;
		const playerAvatar = buildAvatar(this.props, false);

		return (max) ? (
			<div className={'eco-score-tracker__small'}>

				<div className={'eco-pool'}>
					<span>pool</span>
					{this.poolVal(max - currentValue, unit)}
				</div>

				<img className={'eco-arrow'} src={arrow} />

				<div className={'eco-score-tracker__standard__group-wrap'}>
					<EconomicalScoreTrackerPlayer score={currentValue || 0}
																				unit={unit}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-2']} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-3']} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-4']} />
				</div>

			</div>
		) : null;
	}
}
